import { imageCreateErrors } from "./errors.mjs";
import { V2ImageCreateRequestSchema } from "./request.mjs";
import { taskOutputSchema } from "../task/output.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/image/contract.ts
/**
* Public V2 image contract. Mounted at `/image/*` and tagged `Image` in
* the generated OpenAPI spec.
*
* This file is intentionally the *only* place inside the namespace that
* imports from `@orpc/contract`; every other module here exposes pure zod
* schemas / data so they're trivially reusable outside an orpc setting.
*/
const imageContract = oc.prefix("/image").tag("Image").router({ create: oc.route({
	summary: "Create an image generation task",
	method: "POST",
	path: "/create",
	outputStructure: "detailed"
}).input(V2ImageCreateRequestSchema).output(z.object({
	status: z.literal(201),
	body: taskOutputSchema
})).errors(imageCreateErrors) });
//#endregion
export { imageContract };
